var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('AuthApp',{attrs:{"tokenImplicit":_vm.tokenImplicit,"urlClientId":_vm.urlClientId,"urlSecretClient":_vm.urlSecretClient}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }